import { useEffect, useState } from 'react'

import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

const LOAD_MORE_LOADER_TIMEOUT = 500

interface Props {
  visible: boolean
}

export const LoadMoreLoader = ({ visible }: Props) => {
  const [isVisible, setIsVisible] = useState(visible)

  // When the chat list doesn't have many items, the loader is visible
  // for a very short time and it feels like a content flash.
  // This is a workaround to delay the visibility of the loader (just for better UX purposes).
  useEffect(() => {
    if (visible) {
      setIsVisible(true)
      return undefined
    }
    const timer = setTimeout(() => {
      setIsVisible(false)
    }, LOAD_MORE_LOADER_TIMEOUT)

    return () => clearTimeout(timer)
  }, [visible])

  if (!isVisible) {
    return null
  }

  return (
    <div className="p-2">
      <SvgIcon name="spinner" className="animate-spin h-7 w-7" />
    </div>
  )
}
